export default {
  sectionStack: [],
  currentSectionIndex: -1,
  drilledDownCount: 0,
  shouldShowAnswer: false,
  autoSelected: {},
  is_submit_clicked: false,
};
